document.addEventListener("ajaxProduct:added", function (e) {
    const p = e.detail.product;
    const qty = e.detail.quantity ?? 1;
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
            currency: '{{ shop.currency }}',
            value: (p.price * qty) / 100,
            items: [
                {
                    item_name: p.title,
                    item_id: p.id,
                    item_category: p.type,
                    item_brand: p.vendor,
                    price: Number((p.price / 100).toFixed(2)),
                    quantity: qty
                },
            ],
        },
    });
});